import React from "react";
import IMAGES from "../Images";
import styles from "./VoiceDiv3.module.css";
import Heading from "./Heading";
import { MainContainer } from "../assets/styles/theme/styles";
import LinkComponent from "./Link";

export default function VoiceDiv3({ heading, text, image, linkname, linkref }) {
  return (
    <>
      <MainContainer>
        <div className={styles.flex_container}>
          <div className={styles.image_column}>
            <img src={image} alt="" />
          </div>
          <div className={styles.text_container}>
            <Heading level={1} style={{ marginBottom: "2rem" }}>
              {heading}
            </Heading>
            {text.map((item) => {
              return <p key={item}>{item}</p>;
            })}
            {linkref && <LinkComponent text={linkname} href={linkref} />}
          </div>
        </div>
      </MainContainer>
    </>
  );
}
